<awair-device-marker-icon class="__icon"
                          [color]="color"
                          (click)="onClickIcon(deviceUuid)">
</awair-device-marker-icon>
<awair-device-marker-tooltip class="__tooltip"
                             [isOnline]="isOnline"
                             [isSelected]="isSelected"
                             [canClose]="false">
  <h3 class="__name">{{name}}</h3>
  <ng-container *ngIf="isOnline; else disconnected">
    <ng-container *ngIf="value != null; else noSensor">
      <span class="__value">{{value | number: '1.0-0'}}</span><span class="__value">{{unit}}</span>
    </ng-container>
    <ng-template #noSensor>
      <span class="__value">N/A</span>
    </ng-template>
  </ng-container>
  <ng-template #disconnected>
    <span class="__value">Disconnected</span>
  </ng-template>
</awair-device-marker-tooltip>
